import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { FormPersonaJuridicaDto } from '../dto/form-persona-juridica.dto';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-form-persona-juridica',
  templateUrl: './form-persona-juridica.component.html',
  styleUrl: './form-persona-juridica.component.scss',
})
export class FormPersonaJuridicaComponent implements OnChanges, OnInit {
  @Input() camposOcultos: string[] = [];
  @Input() camposInhabilitados: string[] = [];
  @Input() representanteLegal = true;
  @Output() submitAction = new EventEmitter<FormGroup>();
  @Output() changeAction = new EventEmitter<FormGroup>();
  @Input() withSubmitButton = true;
  @Input() data: FormPersonaJuridicaDto = {};

  formFields: FormField[] = [];

  allFields: FormField[] = [
    {
      name: 'razonSocial',
      label: 'Razón social',
      type: 'text',
      required: true,
      placeholder: 'Ingrese la razón social',
      width: '6',
      visible: true,
      validation: [
        Validators.minLength(3),
        Validators.maxLength(100),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ],
      errorMessages: {
        required: 'Razón social es requerido',
        minlength: 'Razón social debe tener como mínimo 3 caracteres',
        maxlength: 'Razón social no puede superar los 100 caracteres',
        pattern:
          'No se permiten espacios al inicio ni al final, ni caracteres especiales.',
      },
      value: this.data.razonSocial,
    },
    {
      name: 'numberOfDocumentNIT',
      label: 'Identificación',
      type: 'number',
      required: true,
      placeholder: 'Ingrese su número de identificación',
      width: '6',
      visible: true,
      validation: [Validators.min(9)],
      errorMessages: {
        required: 'Número de identificación requerido',
      },
      value: this.data.numberOfDocumentNIT,
    },
    {
      name: 'email',
      label: 'Correo electrónico',
      type: 'email',
      required: true,
      placeholder: 'Ingrese su correo electrónico',
      width: '6',
      visible: true,
      validation: [Validators.email],
      errorMessages: {
        required: 'Email es requerido',
        email: 'Formato de correo invalido',
      },
      value: this.data.email,
    },
    {
      name: 'country',
      label: 'País',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El país es requerido' },
      value: this.data.country,
    },
    {
      name: 'departament',
      label: 'Departamento',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El departamento es requerido' },
      value: this.data.departament,
    },
    {
      name: 'municipality',
      label: 'Municipio/ciudad',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'Municipio/ciudad es requerido' },
      value: this.data.municipality,
    },
    {
      name: 'address',
      label: 'Dirección de notificación judicial',
      type: 'text',
      required: true,
      placeholder: 'Ingrese la dirección',
      width: '6',
      visible: true,
      errorMessages: { required: 'La dirección es requerida' },
      value: this.data.address,
    },
    {
      name: 'phone',
      label: 'Teléfono de contacto',
      type: 'text',
      required: true,
      placeholder: 'Ingrese el teléfono',
      width: '6',
      visible: true,
      validation: [
        Validators.minLength(6),
        Validators.maxLength(15),
        Validators.pattern(Constants.REGEX_TELEFONO),
      ],
      errorMessages: {
        required: 'El teléfono es requerido',
        minlength: 'Teléfono de contacto debe contener mínimo 6 dígitos.',
        maxlength: 'Teléfono de contacto no puede superar los 15 dígitos.',
        pattern:
          'Teléfono de contacto solo debe contener números; no se permiten espacios ni caracteres especiales.',
      },
    },
    {
      name: 'attorney',
      label: '¿Actuaré a través de un apoderado?',
      type: 'select',
      required: true,
      options: [
        { Nombre: 'Sí', Id: 1 },
        { Nombre: 'No ', Id: 2 },
      ],
      width: '6',
      visible: true,
      errorMessages: { required: 'El apoderado es requerido' },
      value: this.data.attorney,
    },
    {
      isSubtitle: true,
      subtitleText: 'Datos del representante legal',
      name: 'subTitle',
      label: '',
      type: 'text',
      visible: true,
    },
    {
      name: 'representativeFirstName',
      label: 'Primer Nombre',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su primer nombre ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        required: 'Nombre es requerido',
        maxlength: 'Nombre no puede superar los 25 caracteres',
      },
      value: this.data.representativeFirstName,
    },
    {
      name: 'representativeSecondName',
      label: 'Segundo Nombre',
      type: 'text',
      required: false,
      placeholder: 'Ingrese su segundo nombre ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      errorMessages: { maxlength: 'Nombre no puede superar los 25 caracteres' },
      value: this.data.representativeSecondName,
    },
    {
      name: 'representativFirstLastName',
      label: 'Primer Apellido',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su primer apellido ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        required: 'Apellido es requerido',
        maxlength: 'Apellido no puede superar los 25 caracteres',
      },
      value: this.data.representativFirstLastName,
    },
    {
      name: 'representativeSecondLastName',
      label: 'Segundo Apellido',
      type: 'text',
      required: false,
      placeholder: 'Ingrese su segundo apellido ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        maxlength: 'Apellido no puede superar los 25 caracteres',
      },
      value: this.data.representativeSecondLastName,
    },
    {
      name: 'representativeTypeOfDocument',
      label: 'Tipo de documento',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El documento es requerido' },
      value: this.data.representativeTypeOfDocument,
    },
    {
      name: 'representativeNumberOfDocument',
      label: 'Identificación',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su número de documento',
      width: '6',
      visible: true,
      errorMessages: {
        required: 'Número de documento requerido',
      },
      value: this.data.attorneyNumberOfDocument,
    },
    {
      name: 'representativeEmail',
      label: 'Correo electrónico',
      type: 'email',
      required: true,
      placeholder: 'Ingrese su correo electrónico',
      width: '6',
      visible: true,
      validation: [Validators.email],
      errorMessages: {
        required: 'Email es requerido',
        email: 'Formato de correo invalido',
      },
      value: this.data.representativeEmail,
    },
    {
      name: 'representativeCountry',
      label: 'País',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El país es requerido' },
      value: this.data.representativeCountry,
    },
    {
      name: 'representativeDepartament',
      label: 'Departamento',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El departamento es requerido' },
      value: this.data.attorneyDepartament,
    },
    {
      name: 'representativeMunicipality',
      label: 'Municipio/ciudad',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'Municipio/ciudad es requerido' },
      value: this.data.representativeMunicipality,
    },
    {
      name: 'representativeAddress',
      label: 'Dirección de notificación judicial',
      type: 'text',
      required: true,
      placeholder: 'Ingrese la dirección',
      width: '6',
      visible: true,
      errorMessages: { required: 'La dirección es requerida' },
      value: this.data.representativeAddress,
    },
    {
      isSubtitle: true,
      subtitleText: 'Datos del apoderado',
      name: 'subTitle',
      label: '',
      type: 'text',
      visible: false,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyFirstName',
      label: 'Primer Nombre',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su primer nombre ',
      width: '6',
      visible: false,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        required: 'Nombre es requerido',
        maxlength: 'Nombre no puede superar los 25 caracteres',
      },
      value: this.data.attorneyFirstName,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneySecondName',
      label: 'Segundo Nombre',
      type: 'text',
      required: false,
      placeholder: 'Ingrese su segundo nombre ',
      width: '6',
      visible: false,
      validation: [Validators.maxLength(25)],
      errorMessages: { maxlength: 'Nombre no puede superar los 25 caracteres' },
      value: this.data.attorneySecondName,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyFirstLastName',
      label: 'Primer Apellido',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su primer apellido ',
      width: '6',
      visible: false,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        required: 'Apellido es requerido',
        maxlength: 'Apellido no puede superar los 25 caracteres',
      },
      value: this.data.attorneyFirstLastName,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneySecondLastName',
      label: 'Segundo Apellido',
      type: 'text',
      required: false,
      placeholder: 'Ingrese su segundo apellido ',
      width: '6',
      visible: false,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        maxlength: 'Apellido no puede superar los 25 caracteres',
      },
      value: this.data.attorneySecondLastName,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyTypeOfDocument',
      label: 'Tipo de documento',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: false,
      errorMessages: { required: 'El documento es requerido' },
      value: this.data.attorneyTypeOfDocument,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyNumberOfDocument',
      label: 'Identificación',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su número de documento',
      width: '6',
      visible: false,
      errorMessages: {
        required: 'Número de documento requerido',
      },
      value: this.data.attorneyNumberOfDocument,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyProfessionalCard',
      label: 'Número de tarjeta profesional',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su número de tarjeta profesional',
      width: '6',
      visible: false,
      validation: [
        Validators.minLength(3),
        Validators.maxLength(12),
        Validators.pattern(Constants.REGEX_TELEFONO),
      ],
      errorMessages: {
        required: 'Número de tarjeta profesional requerido',
        minlength:
          'Número de tarjeta profesional debe contener mínimo 3 caracteres',
        maxlength:
          'Número de tarjeta profesional no puede superar los 12 caracteres',
        pattern:
          'Número de tarjeta profesional solo debe contener números; no se permiten espacios, ni caracteres especiales.',
      },
      value: this.data.attorneyProfessionalCard,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyEmail',
      label: 'Correo electrónico',
      type: 'email',
      required: true,
      placeholder: 'Ingrese su correo electrónico',
      width: '6',
      visible: false,
      validation: [Validators.email],
      errorMessages: {
        required: 'Email es requerido',
        email: 'Formato de correo invalido',
      },
      value: this.data.attorneyEmail,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyPhone',
      label: 'Número de teléfono',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su número de teléfono',
      width: '6',
      visible: false,
      validation: [
        Validators.minLength(6),
        Validators.maxLength(15),
        Validators.pattern(Constants.REGEX_TELEFONO),
      ],
      errorMessages: {
        required: 'El teléfono es requerido',
        minlength: 'Teléfono debe contener mínimo 6 dígitos.',
        maxlength: 'Teléfono no puede superar los 15 dígitos.',
        pattern:
          'Teléfono solo debe contener números; no se permiten espacios ni caracteres especiales.',
      },
      value: this.data.attorneyPhone,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyCountry',
      label: 'País',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: false,
      errorMessages: { required: 'El país es requerido' },
      value: this.data.attorneyCountry,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyDepartament',
      label: 'Departamento',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: false,
      errorMessages: { required: 'El departamento es requerido' },
      value: this.data.attorneyDepartament,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyMunicipality',
      label: 'Municipio/ciudad',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: false,
      errorMessages: { required: 'Municipio/ciudad es requerido' },
      value: this.data.attorneyMunicipality,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
    {
      name: 'attorneyAddress',
      label: 'Dirección de notificación judicial',
      type: 'text',
      required: true,
      placeholder: 'Ingrese la dirección',
      width: '6',
      visible: false,
      errorMessages: { required: 'La dirección es requerida' },
      value: this.data.attorneyAddress,
      dependsOn: 'attorney',
      visibilityCondition: value => value == 1,
    },
  ];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['camposOcultos']) {
      this.formFields = this.allFields.filter(
        field => !this.camposOcultos.includes(field.name)
      );
    }
  }

  ngOnInit() {
    this.formFields = this.allFields
      .filter(field => !this.camposOcultos.includes(field.name))
      .map(field => {
        if (this.camposInhabilitados.includes(field.name)) {
          field.disabled = true;
        }

        if (this.data[field.name as keyof typeof this.data] !== undefined) {
          field.value = this.data[field.name as keyof typeof this.data];
        }

        return field;
      });
  }

  onSubmit(form: FormGroup) {
    this.submitAction.emit(form);
  }

  onChanges(form: FormGroup): void {
    this.changeAction.emit(form);
  }
}
